
<app-admin-side-bar></app-admin-side-bar>

  <!-- Navbar -->
  <nav class="main-header navbar navbar-expand navbar-dark">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" appRemoveOverlayDirective data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
      </li>
      <li class="nav-item d-none d-sm-inline-block">
        <a class="nav-link">Home</a>
      </li>
      <li class="nav-item d-none d-sm-inline-block">
        <a class="nav-link">Order History Report</a>
      </li>
    </ul>
  
    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto" *ngIf="Role=='1'">
      <li class="nav-item dropdown">
        <a><app-admin-test-mode></app-admin-test-mode> </a>
      </li>
    </ul>
  </nav>
  <!-- /.navbar -->



<div class="content-wrapper">
  <section class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1>Order Report</h1>
        </div>
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a>Home</a></li>
            <li class="breadcrumb-item active">Order Report</li>
          </ol>
        </div>
      </div>
    </div>
    <!-- /.container-fluid -->
  </section>

  <div class="container-fluid" style="padding: 15px">
    <div class="row">
      <section *ngIf="Role == 1" class="col-md-12">
        <button class="btnDef" (click)="exportToCSV()">Export CSV</button>
        &nbsp;&nbsp;
        <button class="btnDef" (click)="exportDataPDF()">Export PDF</button>
      </section>
    </div>
    <br />

    <div class="row">
      <!-- <section *ngIf="Role==1" class="col-md-3">
                  <button type="button" (click)="openCreateModal()" class="btn btn-primary">
                      Add New
                  </button>
  
              </section> -->
      <div class="col-md-2 col-sm-3">
        <select class="form-control" (change)="onSelectChange($event.target)">
          <option>Select</option>
          <option value="1">Today</option>
          <option value="2">Yesterday</option>
          <option value="3">This week</option>
          <option value="4">Last Week</option>
          <option value="5">This Month</option>
          <option value="6">Last Month</option>
          <option value="7">Custom</option>
        </select>
      </div>
      <div class="col-md-3 col-sm-5" *ngIf="boolCustom">
        <mat-form-field style="height: 50px" class="example-full-width mb-3">
          <mat-date-range-input
            style="margin-top: -12px"
            [rangePicker]="picker"
          >
            <input
              style="position: absolute; top: 0px"
              matStartDate
              placeholder="Start Date & Time"
              [(ngModel)]="startDate"
            />
            <input
              matEndDate
              placeholder="End Date & Time"
              [(ngModel)]="endDate"
            />
          </mat-date-range-input>
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div>
      <section class="col-md-3">
        <mat-form-field
          style="height: 50px; margin-left: 9px"
          appearance="fill"
        >
          <mat-select
            (selectionChange)="filterRetailers($event)"
            style="position: absolute; top: 0px"
            #retailerSelect
            [placeholder]="'Select Retailer'"
          >
            <mat-option [value]="0">Select Retailer</mat-option>
            <!-- <input class="filterTextBox" matInput placeholder="'Search retailer'" [(ngModel)]="filterRetailer"
              (keyup)="filterRetailers($event.target)" autocomplete="off"> -->
            <mat-option
              (selectionChange)="filterRetailers($event.target)"
              *ngFor="let retailer of Retailers"
              [value]="retailer.id"
            >
              {{ retailer.fullName }}
            </mat-option>
          </mat-select>
          <button
            style="width: 10% !important; border: 0px"
            mat-button
            matSuffix
            (click)="retailerSelect.open()"
          ></button>
        </mat-form-field>
      </section>

      <section class="col-md-2 col-sm-3" style="float: right">
        <div class="form-group d-flex align-items-center mx-2">
          <label for="filter" class="mr-2 mb-0">Filter:</label>
          <input
            type="text"
            class="form-control"
            id="filter"
            #keyword
            placeholder="Search"
          />
        </div>
      </section>

      <div class="col-1 mt-1 mx-2">
        <button class="btnDef" (click)="Filter(keyword.value)">Search</button>
      </div>
      <div class="col-1 mt-1 mx-2">
        <!-- <button class="btnDef" (click)="printAllRecords()">PrintAll</button> -->
        <a href="javascript:void(0)" (click)="printAllRecords()" class="btnDef1">PrintAll</a>
      </div>
      <section class="col-md-12 mt-2">
        <div class="card">
          <!-- /.card-header -->
          <div class="card-body">
            <div class="row">
              <div class="col-5"></div>
              <div class="col-2">
                <div *ngIf="loader == true">
                  <app-loader style="text-align: center"></app-loader>
                </div>
              </div>
              <div class="col-5"></div>
            </div>

            <!-- <div class="row">
              <div class="col-md-6 col-xl-6" *ngIf="Role == 1">
                <div class="card bg-c-blue order-card">
                  <div class="card-block card-size">
                    <b>All Orders</b
                    ><b style="float: right">{{ OrderCounts.allOrderCount }}</b>
                    <br />
                    <b>All Order Total Amount</b>
                    <b style="float: right">{{
                      OrderCounts.allOrderTotalAmount
                    }}</b>
                    <br />
                    <b>All Order Total Discount</b>
                    <b style="float: right">{{
                      OrderCounts.allOrderTotalDiscount
                    }}</b>
                    <br />
                    <b>All Order Total Discount Amount</b>
                    <b style="float: right">{{
                      OrderCounts.allOrderTotalDiscountedAmount
                    }}</b>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-xl-6" *ngIf="Role == 1">
                <div class="card bg-c-green order-card">
                  <div class="card-block card-size">
                    <h2>Processing Orders</h2>
                    <h3>
                      {{ OrderCounts.processingCount }}
                    </h3>
                    <br />
                  </div>
                </div>
              </div>
            </div> -->

            <div class="row">
              <div class="col-md-12">
                <table
                *ngIf="loader == false"
                id="example2"
                class="table table-bordered table-hover table-responsive"
              >
                <thead>
                  <tr>
                    <th>Date / Time</th>
                    <th>Sender Name</th>
                    <th>Sender Phone</th>
                    <th>Receiver Name</th>
                    <th>Receiver PhoneNumber</th>
                    <th>Retailer</th>
                    <th *ngIf="showOrderDetails">Total Discount</th>
                    <th *ngIf="showOrderDetails">Discounted Amount</th>
                    <th *ngIf="showOrderDetails">Total Amount</th>
                    <th>Order Number</th>
                    <th>Order Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody *ngFor="let item of orderHistories; let i = index">
                  <tr>
                    <td>{{ item.orderDate | date:'short'}}</td>
                    <td>{{ item.senderName }}</td>
                    <td>{{ item.senderPhone }}</td>
                    <td>{{ item.receiverName }}</td>
                    <td>{{ item.receiverPhone }}</td>
                    <td>{{ item.retailerName }}</td>
                    <td *ngIf="showOrderDetails">{{item.totalDiscount}}</td>
                    <td *ngIf="showOrderDetails">{{item.totalDiscountedAmount}}</td>
                    <td *ngIf="showOrderDetails">{{ item.totalAmount }}</td>
                    <td>
                      {{ item.orderNumber }}
                      <span
                        style="background: transparent; cursor: pointer"
                        class="mx-2"
                        (click)="PrintRecipt(item.orderNumber)"
                      >
                        <i class="fa fa-print"></i
                      ></span>
                    </td>
                    <td>
                      <!-- <ng-container [ngSwitch]="item.orderStatus">
                        <span class="status-primary" *ngSwitchCase="1"
                          >Processing</span
                        >
                        <span class="status-success" *ngSwitchCase="2"
                          >Out for Delivery</span
                        >
                        <span class="status-success" *ngSwitchCase="3"
                          >Delivered</span
                        >
                        <span  matTooltip={{item.remarks}} class="status-primary" *ngSwitchCase="4"
                          >Pending</span
                        >
                        <span class="status-warning" *ngSwitchCase="5"
                          >Cancelled</span
                        > -->
                        <span style="font-size: 15px;font-weight: bold;" [class]="getStatusClass(item.orderStatus)">
                        <!-- matTooltip="{{ item.orderStatus === OrderStatus.Processing && item.remarks ? item.remarks : '' }}"
                        [ngClass]="{
                          'status-primary': item.orderStatus === getOrderStatusLabel.Processing,
                          'status-success': item.orderStatus === OrderStatus.Delivered || item.orderStatus === OrderStatus.OutForDelivery,
                          'status-warning': item.orderStatus === OrderStatus.Pending,
                          'status-default': item.orderStatus === OrderStatus.Canceled
                        }"
                      > -->
                        <!-- {{ getOrderStatusLabel(item.orderStatus) }} -->
                          <!-- {{getOrderStatusLabel(item.orderStatus)}} -->
                           {{item.orderStatus}}
                      </span>
                      <span *ngIf="item.remarks" title="{{item.remarks}}" style="font-size: 18px; font-weight: bold;
                      color: red;cursor: pointer;">
                        ?
                      </span>
                      
                    </td>
                    <td class="d-flex justify-content-center align-items-center">
                      <!-- View Icon -->
                      <i
                        class="fa fa-eye fa-2x mx-2"
                        style="font-size: 16px"
                        (click)="itemDetails(item.orderNumber)"
                      ></i>
  
                      <!-- Update Status Icon -->
                      <span
                        class="mx-2"
                        (click)="
                          NavigateToUpdateStatus(
                            item.orderNumber,
                            item.orderStatus
                          )
                        "
                      >
                        <i
                          class="fa fa-cloud-upload-alt"
                          style="font-size: 16px"
                        ></i>
                      </span>
  
                      <!-- Print Receipt Icon -->
                      <!-- <span class="mx-2" (click)="PrintRecipt(item.orderNumber)">
                          <i class="fa fa-print" style="font-size: 16px;"></i>
                      </span> -->
                    </td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>
           
          </div>
          <div class="d-flex justify-content-center my-3" *ngIf="totalItems > 0">
            <app-pager [totalCount]="totalItems" [pageSize]="10" (pageChanged)="onPageChanged($event)"></app-pager>
          </div>

          <!-- /.card-body -->
        </div>
      </section>
    </div>
  </div>
</div>
